(() => {
  // Keep gallery height synchronization without installing material zoom controls.
  const init = () => document.querySelectorAll('gallery-carousel').forEach(gallery => {
    if (gallery.dataset.materialLensReady) return;
    gallery.dataset.materialLensReady = 'true';
    const stickyGallery = gallery.closest('.wallify-pdp-optimized .product__column-sticky');
    if (stickyGallery && window.ResizeObserver) {
      const resizeObserver = new ResizeObserver(() => {
        if (!stickyGallery.isConnected) { resizeObserver.disconnect(); return; }
        stickyGallery.style.setProperty('--wallify-gallery-height', stickyGallery.getBoundingClientRect().height + 'px');
      });
      resizeObserver.observe(stickyGallery);
    }
  });
  init();new MutationObserver(init).observe(document.body,{childList:true,subtree:true});
})();
